import { Toaster } from '@/_components/ui/sonner'
import { QueryClientProvider } from '@/_providers/query-client-provider'
import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <QueryClientProvider>
      <Outlet />
      <Toaster richColors theme="light" />
    </QueryClientProvider>
  ),
})
